export const initialState = {
  //pocName=ali&qty=10&serviceArea=islamabad&serviceCharges=100&serviceCountry=paksitan&serviceRange=national
  values: {
    agriServiceDescription: "",//
    agriServiceId: "",//
    pocName: '',//
    serviceName: '',//
    serviceCharges: '',//
    serviceRange: '',//
    serviceArea: '',//
    currency: '',//
    franchise: '',//
    file: '',
    qty: '',//
    description: '',//
    certification: '',//
    certificateFile: '',//
    businessName: '',//
    contactNumber: '',//
    serviceCountry: '',//
    state: '',
    measurementUnit: '',
  },
  errors: {
    agriServiceDescription: "",//
    agriServiceId: "",//
    pocName: '',//
    serviceName: '',//
    serviceCharges: '',//
    serviceRange: '',//
    serviceArea: '',//
    currency: '',//
    franchise: '',//
    description: '',
    file: '',
    qty: '',//
    certification: '',//
    certificateFile: '',//
    businessName: '',//
    contactNumber: '',//
    serviceCountry: '',//
    measurementUnit: '',
  },
}


export const serviceAreaOption = [
  {text: "ProvenceWise", value: "provenceWise"},
  {text: "National", value: "national"},
  {text: "InterNational", value: "international"},
  {text: "WorldWide", value: "worldwide"}
]

export const measurementUnitOption = [
  {text: "KM", value: "KM"},
  {text: "Gram", value: "Gram"},
  {text: "Container", value: "Container"},
  {text: "Number", value: "Number"}
]
